export default __webpack_public_path__ + "static/media/img8.63517296.jpg";